// Vendors
import * as WebFont from "webfontloader";
import {
    Loader,
    Texture,
    BaseTexture
} from 'pixi.js';

export class LoaderService {
    private static loaders: Loader[] = [];

    public static get loader(): Loader {
        let loader: Loader = null;
        loader = new Loader();
        LoaderService.loaders.push(loader);
        return loader;
    }

    public static async loadAssets(loader: Loader): Promise < object > {
        return new Promise((resolve, reject) => {
            loader.load(() => {
                resolve({});
            });
        });
    }

    public static getResource(name: string): PIXI.LoaderResource {
        let resource: PIXI.LoaderResource = null;
        for (let i = 0; i < LoaderService.loaders.length; i++) {
            if (LoaderService.loaders[i].resources[name]) {
                resource = LoaderService.loaders[i].resources[name];
                break;
            }
        }
        return resource;
    }

    public static getSpritesheet(name: string): PIXI.Spritesheet {
        let resource: PIXI.LoaderResource = null;
        for (let i = 0; i < LoaderService.loaders.length; i++) {
            if (LoaderService.loaders[i].resources[name]) {
                resource = LoaderService.loaders[i].resources[name];
                break;
            }
        }
        return resource.spritesheet;
    }

    public static checkResourceLoaded(key: string): boolean {
        let isLoaded: boolean = false;
        for (let i = 0; i < LoaderService.loaders.length; i++) {
            if (LoaderService.loaders[i].resources[key]) {
                isLoaded = true;
                break;
            }
        }
        return isLoaded;
    }

    public static async awaitLoadCompleted(loader: Loader): Promise < object > {
        return new Promise((resolve) => {
            if (loader.loading || loader.progress < 100)
                loader.onComplete.add(() => {
                    resolve({});
                });
            else{
                resolve({});
            }
        });
    }

    public static async loadTexture(url: string): Promise < Texture > {
        return new Promise < Texture > ((resolve) => {
            const img = new Image();
            img.crossOrigin = '';
            img.src = url;
            img.onload = () => {
                const base = new BaseTexture(img);
                resolve(new Texture(base));
            }
        });
    }





    public static loadFont(): Promise<object> {
        return new Promise(resolve => {
            //loading fonts
            WebFont.load({
                custom: {
                    families: ["Neue_Helvetica_bold", "Helvetica_Neue", "Neue_Helvetica_light"],
                },
                active: () => {
                    resolve({});
                },
            });
            // resolve({});
        });
    }
}